import {
  Box,
  Button,
  makeStyles,
  Step,
  StepLabel,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import DottedLine from "../Stepper Components/dottedLine";
import Stepper from "../Stepper Components/Stepper";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    backgroundColor: "white",
    padding: "4.4rem",
    width: "23rem",
    marginRight: "6rem",
    borderRadius: "8px",
    // height: "100%",
  },
}));
const ProjectRegistrationStepper = ({ currentStep, maxSteps }) => {
  const classes = useStyles();
  // console.log({ maxSteps });

  const [steps, setSteps] = useState([
    "Project detail",
    "Funds detail",
    "Contact detail",
    "Token detail",
  ]);

  return (
    <Box className={classes.container}>
      <Stepper name={steps[0]} count={1} currentStep={currentStep} />
      <DottedLine count={1} currentStep={currentStep} />
      <Stepper name={steps[1]} count={2} currentStep={currentStep} />
      <DottedLine count={2} currentStep={currentStep} />
      <Stepper name={steps[2]} count={3} currentStep={currentStep} />
      {maxSteps == 4 ? (
        <>
          <DottedLine count={3} currentStep={currentStep} />
          <Stepper name={steps[3]} count={4} currentStep={currentStep} />
        </>
      ) : null}
    </Box>
  );
};

export default ProjectRegistrationStepper;
